import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import { type PurchaseOrderDetailInitialStateType } from 'features/PurchaseOrder/@types/PurchaseOrder'
import {
  fetchPurchaseOrderDetail,
  SLICE_NAME_PURCHASE_ORDER_DETAIL,
  uploadGrnOrDeliveryNoteData,
  submitDocumentGrnOrDeliveryNoteData,
  getPoDocumentsData,
} from './thunk'

const initialState: PurchaseOrderDetailInitialStateType = {
  isLoading: false,
  detail: null,
  tags: [],
  remarks: [],
  uploadedDocuments: {
    grn: [],
    deliveryNotes: [],
  },
}

const slice = createSlice({
  name: SLICE_NAME_PURCHASE_ORDER_DETAIL,
  initialState,
  reducers: {
    resetPurchaseOrderDetailState: () => initialState,
    setUploadedDocuments: (
      state,
      action: PayloadAction<Partial<PurchaseOrderDetailInitialStateType['uploadedDocuments']>>,
    ) => {
      state.uploadedDocuments = { ...state.uploadedDocuments, ...action.payload }
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<PurchaseOrderDetailInitialStateType>) => {
      builder
        .addCase(fetchPurchaseOrderDetail.fulfilled, (state, { payload }) => {
          state.detail = payload.data
          state.tags = payload.tags?.sort((a, b) => a.id - b.id) ?? []
          state.remarks = payload.remarks ?? []
        })
        .addCase(uploadGrnOrDeliveryNoteData.fulfilled, (state, { payload }) => {
          if (payload) {
            state.uploadedDocuments.grn = [...state.uploadedDocuments.grn, ...payload.grn]
            state.uploadedDocuments.deliveryNotes = [
              ...state.uploadedDocuments.deliveryNotes,
              ...payload.deliveryNotes,
            ]
          }
        })
        .addCase(getPoDocumentsData.fulfilled, (state, { payload }) => {
          state.uploadedDocuments = {
            grn: payload
              .filter((doc) => doc.type === 'GRN')
              .map((doc) => ({ fileUrl: doc.file_url, isNew: false })),
            deliveryNotes: payload
              .filter((doc) => doc.type === 'SURAT_JALAN')
              .map((doc) => ({ fileUrl: doc.file_url, isNew: false })),
          }
        })
    },
    [fetchPurchaseOrderDetail, uploadGrnOrDeliveryNoteData, submitDocumentGrnOrDeliveryNoteData],
  ),
})

export const { resetPurchaseOrderDetailState, setUploadedDocuments } = slice.actions

export default slice.reducer
